export function matchGlove(product, answer, stock) {
  const tags = new Set(product.tags || []), has = value => tags.has(value);
  if (!has('catalog:glove') || !has('sport:' + answer.sport)) return null;
  if (answer.position !== 'fielding' && !has('position:' + answer.position)) return null;
  if (answer.age === 'youth' && !has('age:youth')) return null;
  const mixed = product.variants.some(v => /kids|teenagers|adults/i.test(v.title));
  if (answer.age !== 'youth' && has('age:youth') && !mixed) return null;
  const knownReady = has('breakin:ready'), knownTraditional = has('breakin:traditional');
  if (answer.breakin === 'ready' && knownTraditional || answer.breakin === 'traditional' && knownReady) return null;
  const variants = product.variants.filter(v => {
    if (!v.available || answer.budget && v.price > Number(answer.budget) * 100) return false;
    const saved = stock?.variants.find(x => String(x.id) === String(v.id));
    if (saved && !saved.stocked) return false;
    if (mixed && !new RegExp(answer.age === 'youth' ? 'kids' : answer.age === 'teen' ? 'teenagers' : 'adults', 'i').test(v.title)) return false;
    const text = v.title.toLowerCase();
    if (/\blht\b|left.hand.throw/.test(text) && answer.hand !== 'lht') return false;
    if (/\brht\b|right.hand.throw/.test(text) && answer.hand !== 'rht') return false;
    if (has('throw:rht') && !has('throw:lht') && answer.hand !== 'rht') return false;
    if (has('throw:lht') && !has('throw:rht') && answer.hand !== 'lht') return false;
    return true;
  }).sort((a,b) => a.price-b.price);
  if (!variants.length) return null;
  const variant=variants[0], text=variant.title.toLowerCase();
  const handKnown = answer.hand === 'rht' ? /\brht\b|right.hand.throw/.test(text) || has('throw:rht') && !has('throw:lht') : /\blht\b|left.hand.throw/.test(text) || has('throw:lht') && !has('throw:rht');
  const breakKnown=knownReady||knownTraditional;
  return {product,variant,handKnown,breakKnown,knownReady,score:(handKnown?10:0)+(answer.breakin!=='any'&&breakKnown?4:0)};
}

if (typeof customElements !== 'undefined' && !customElements.get('proplay-game-finder')) customElements.define('proplay-game-finder', class extends HTMLElement {
  connectedCallback() {
    if(this.control)return;
    this.control=new AbortController();this.run=0;
    this.form=this.querySelector('form');this.results=this.querySelector('[data-results]');this.status=this.querySelector('[data-status]');
    this.labels=JSON.parse(this.querySelector('[data-labels]').textContent);this.catalog=JSON.parse(this.querySelector('[data-products]').textContent);
    const params=new URLSearchParams(location.search),aliases={throw:'hand',group:'age'};
    for(const [key,value] of params){const field=this.form.elements[aliases[key]||key];if(field?.tagName==='SELECT'&&Array.from(field.options).some(o=>o.value===value))field.value=value;}
    this.form.addEventListener('submit',e=>{e.preventDefault();this.search();},{signal:this.control.signal});
    this.form.addEventListener('reset',()=>{this.run++;this.results.replaceChildren();this.status.textContent='';this.querySelector('[type=submit]').disabled=false;},{signal:this.control.signal});
    this.stepify();
  }
  /* One question at a time: each select becomes a step of large answer buttons.
     The native selects stay in the form (hidden) so FormData and the no-JS form keep working. */
  stepify(){
    const form=this.form,l=this.labels,labels=[...form.querySelectorAll(':scope > label')];
    if(!labels.length||form.dataset.stepped)return;
    form.dataset.stepped='1';this.classList.add('ppgf-stepped');
    const signal=this.control.signal,total=labels.length;
    const head=this.node('div',null,'ppgf-head'),count=this.node('p',null,'ppgf-count'),bar=this.node('div',null,'ppgf-bar');
    count.setAttribute('aria-live','polite');bar.setAttribute('aria-hidden','true');
    const fills=labels.map(()=>{const s=this.node('span');bar.append(s);return s;});
    head.append(count,bar);
    const stage=this.node('div',null,'ppgf-stage'),summary=this.node('div',null,'ppgf-summary');summary.hidden=true;
    const nav=this.node('div',null,'ppgf-nav'),back=this.node('button',l.step_back||'Back','ppgf-back');back.type='button';nav.append(back);
    const steps=labels.map((label,i)=>{
      const select=label.querySelector('select');
      const question=[...label.childNodes].filter(n=>n.nodeType===3).map(n=>n.textContent).join(' ').trim();
      const set=document.createElement('fieldset');set.className='ppgf-step';set.hidden=true;
      const legend=this.node('legend',question,'ppgf-q');legend.tabIndex=-1;set.append(legend);
      const opts=this.node('div',null,'ppgf-opts');
      const buttons=[...select.options].map(option=>{
        const b=this.node('button',option.textContent.trim(),'ppgf-opt');b.type='button';b.dataset.value=option.value;
        b.addEventListener('click',()=>{select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));this.markStep(i);if(i<total-1)this.goStep(i+1,true);else this.finishSteps();},{signal});
        opts.append(b);return b;
      });
      set.append(opts);stage.append(set);label.hidden=true;
      return {set,legend,select,buttons,question};
    });
    form.prepend(head);head.after(stage);stage.after(summary);summary.after(nav);
    const actions=form.querySelector('.ppcx-actions'),submit=form.querySelector('[type=submit]');
    if(submit)submit.hidden=true;
    back.addEventListener('click',()=>{if(this.stepIndex>=total)this.goStep(total-1,true);else if(this.stepIndex>0)this.goStep(this.stepIndex-1,true);},{signal});
    form.addEventListener('reset',()=>{setTimeout(()=>{steps.forEach((_,i)=>this.markStep(i));this.goStep(0,true);});},{signal});
    this.stepParts={steps,count,fills,summary,back,total,actions};
    steps.forEach((_,i)=>this.markStep(i));
    this.goStep(0,false);
  }
  markStep(i){const s=this.stepParts?.steps[i];if(!s)return;for(const b of s.buttons)b.setAttribute('aria-pressed',String(b.dataset.value===s.select.value));}
  goStep(i,focus){
    const p=this.stepParts,l=this.labels;if(!p)return;this.stepIndex=i;
    p.steps.forEach((s,n)=>{s.set.hidden=n!==i;});
    p.summary.hidden=true;p.back.hidden=i===0;
    p.fills.forEach((f,n)=>f.classList.toggle('is-done',n<i));p.fills.forEach((f,n)=>f.classList.toggle('is-now',n===i));
    p.count.textContent=(l.step_label||'Question')+' '+(i+1)+' '+(l.step_of||'of')+' '+p.total;
    if(focus)p.steps[i].legend.focus({preventScroll:true});
  }
  finishSteps(){
    const p=this.stepParts;if(!p)return;this.stepIndex=p.total;
    p.steps.forEach(s=>{s.set.hidden=true;});p.back.hidden=false;
    p.fills.forEach(f=>{f.classList.add('is-done');f.classList.remove('is-now');});
    p.count.textContent=this.labels.results||'';
    p.summary.replaceChildren();p.summary.hidden=false;
    p.steps.forEach((s,i)=>{
      const chosen=s.select.options[s.select.selectedIndex];
      const chip=this.node('button',chosen?chosen.textContent.trim():'','ppgf-chip');chip.type='button';
      chip.setAttribute('aria-label',s.question+': '+(chosen?chosen.textContent.trim():''));
      chip.addEventListener('click',()=>this.goStep(i,true),{signal:this.control.signal});
      p.summary.append(chip);
    });
    this.search();
  }
  disconnectedCallback(){this.control?.abort();this.control=null;this.run++;}
  node(tag,text,cls){const n=document.createElement(tag);if(text)n.textContent=text;if(cls)n.className=cls;return n;}
  link(text,url,cls){const a=this.node('a',text,cls);a.href=url;return a;}
  async load(handle){const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),8000);try{const r=await fetch(this.dataset.root+'products/'+encodeURIComponent(handle)+'.js',{signal:controller.signal});if(!r.ok)throw Error('listing');return await r.json();}finally{clearTimeout(timer);}}
  async search(){
    const ticket=++this.run, button=this.querySelector('[type=submit]'), labels=this.labels;
    button.disabled=true;this.status.textContent=labels.loading;this.results.replaceChildren();
    const answer=Object.fromEntries(new FormData(this.form)),response=await Promise.allSettled(this.catalog.map(p=>this.load(p.handle)));
    if(ticket!==this.run||!this.isConnected)return;
    const matches=response.flatMap((item,i)=>item.status==='fulfilled'?[matchGlove(item.value,answer,this.catalog[i])].filter(Boolean):[]).sort((a,b)=>b.score-a.score||a.variant.price-b.variant.price);
    const matched=matches.filter(x=>x.handKnown),confirm=matches.filter(x=>!x.handKnown);
    if(!matches.length)this.results.append(this.node('p',labels.empty));
    for(const [items,title] of [[matched,labels.matched],[confirm,labels.confirm]]){
      if(!items.length)continue;
      const section=this.node('section',null,'ppcx-results');section.append(this.node('h2',title));const grid=this.node('div',null,'ppcx-grid');
      for(const result of items.slice(0,6))grid.append(this.card(result,answer));section.append(grid);this.results.append(section);
    }
    this.status.textContent=response.some(x=>x.status==='rejected')?labels.error:matches.length+' '+labels.results.toLowerCase();button.disabled=false;
    this.results.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  }
  card(result,answer){
    const {product:p,variant:v,handKnown,breakKnown,knownReady}=result,l=this.labels,card=this.node('article',null,'ppcx-card');
    if(p.featured_image){const image=document.createElement('img');image.src=p.featured_image;image.alt=p.title;image.loading='lazy';image.width=440;image.height=220;card.append(image);}
    card.append(this.node('p',l.available,'ppcx-badge'),this.node('h3',p.title));
    card.append(this.node('p',new Intl.NumberFormat(undefined,{style:'currency',currency:this.dataset.currency}).format(v.price/100),'ppcx-price'));
    card.append(this.node('strong',l.why));const reasons=this.node('ul');
    const sport=this.node('li',l[answer.sport]);reasons.append(sport);
    if(answer.position!=='fielding')reasons.append(this.node('li',l[answer.position]));
    if(answer.budget)reasons.append(this.node('li',l.budget+': '+new Intl.NumberFormat(undefined,{style:'currency',currency:this.dataset.currency}).format(Number(answer.budget))));
    if(handKnown)reasons.append(this.node('li',l[answer.hand]));card.append(reasons);
    if(v.title!=='Default Title')card.append(this.node('p',l.size+': '+v.title));
    if(!handKnown)card.append(this.node('p',l.unknown_hand,'ppcx-warning'));
    if(breakKnown)card.append(this.node('p',knownReady?l.ready_note:l.traditional_note));else if(answer.breakin!=='any')card.append(this.node('p',l.unknown_break,'ppcx-warning'));
    const url=this.dataset.root+'products/'+encodeURIComponent(p.handle)+'?variant='+encodeURIComponent(v.id);
    card.append(this.link(l.details,url,'ppcx-button'));
    card.append(this.link(l.ask,this.dataset.contact+'?model='+encodeURIComponent(p.title+' — '+v.title)));
    return card;
  }
});
